import { getDayOfYear, getMonthOfYear, getYear } from "./date";
const isInitUtmSent = "utmas"; // utmas utm already sent
export const getUtmAndCohort = () => {
    let cohort = {};
    let initialUtm = {};
    let utm = {};
    const addInitUtm = localStorage.getItem(isInitUtmSent) !== "true";
    if (addInitUtm) {
        initialUtm = getInitUtm();
        localStorage.setItem(isInitUtmSent, "true");
    }
    utm = getUtm();
    cohort = utm.utm_source ? getCohort() : {};
    return { utm, cohort, initialUtm };
};
const getUtm = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsMap = {};
    searchParams.forEach((value, key) => {
        paramsMap[key] = value;
    });
    return paramsMap;
};
const getInitUtm = () => {
    const searchParams = getUtm();
    return {
        initial_utm_source: searchParams.utm_source,
        initial_utm_medium: searchParams.utm_medium,
        initial_utm_campaign: searchParams.utm_campaign,
        initial_utm_term: searchParams.utm_term,
        initial_utm_content: searchParams.utm_content,
        initial_gclid: searchParams.gclid,
        initial_fbclid: searchParams.fbclid,
        initial_utm_ad: searchParams.utm_ad,
        initial_utm_placement: searchParams.utm_placement,
        initial_utm_id: searchParams.utm_id,
        initial_ad_id: searchParams.ad_id,
    };
};
const getCohort = () => {
    const cohortMap = {};
    cohortMap.cohort_day = getDayOfYear();
    cohortMap.cohort_month = getMonthOfYear();
    cohortMap.cohort_year = getYear();
    return cohortMap;
};
